module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qStem"
  }, [_c('p', {
    staticClass: "qDescript",
    domProps: {
      "innerHTML": _vm._s(_vm.question.question_description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-20"
  }, [(_vm.question.sid > -1 && _vm.moduleId != 15) ? _c('span', {
    staticClass: "queNum"
  }, [_vm._v(_vm._s(_vm.question.sid + 1) + ". ")]) : _vm._e(), _vm._v(" "), (_vm.question.question_ref_sorce) ? _c('span', [_vm._v("(" + _vm._s(_vm.question.question_ref_sorce || 0) + "分, " + _vm._s(_vm.question.difficultyDegree) + "难度)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "qStemC"
  }, [_c('div', {
    staticClass: "qsamllStem",
    domProps: {
      "innerHTML": _vm._s(_vm.fillFormatHtml(_vm.question.stem))
    }
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "attachments": _vm.question.attachments,
      "playerObj": _vm.playerObj,
      "id": _vm.question.id
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }), _vm._v(" "), (_vm.moduleId == 124) ? _c('tabTopic', {
    attrs: {
      "infoAnswer": _vm.question.ref_info && _vm.question.ref_info.answers[0],
      "knowledgePoints": _vm.question.knowledge_points,
      "skillPoints": _vm.question.skill_points,
      "explains": _vm.question.explains,
      "tags": _vm.question.tags,
      "qtype": 4,
      "isObject": true
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.question.children), function(question, index) {
    return _c('div', {
      staticClass: "m-t20"
    }, [(question.qtype == 1) ? _c('singleChoice', {
      attrs: {
        "question": question,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "parentqtype": question.qtype,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj
      }
    }) : (question.qtype == 3) ? _c('filling', {
      attrs: {
        "question": question,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "parentqtype": question.qtype,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj,
        "correctScore": _vm.correctScore
      }
    }) : (question.qtype == 6) ? _c('shortanswer', {
      attrs: {
        "question": question,
        "underlineF": true,
        "id": question.id + index,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "parentqtype": question.qtype,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj
      }
    }) : (question.qtype == 7) ? _c('imitation', {
      attrs: {
        "question": question,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "parentqtype": question.qtype,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj
      }
    }) : _vm._e()], 1)
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-3e88c500","hasScoped":false}!./~/.12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/question/allFilling.vue
// module id = 184
// module chunks = 1